import { createReducer, on } from '@ngrx/store';
import { loadVehicle } from '@store/actions/vehicle.actions';
import { GetVehicleResponse } from '../../../features/vehicles/domain/vehicle.model';
import { MroReason } from '../../../features/vehicles/infrastructure/enums/mro-reason.enum';
import { MroStatus } from '../../../features/vehicles/infrastructure/enums/mro-status.enum';
import { MROType } from '../../../features/vehicles/infrastructure/enums/mro-type.enum';
import { ReadingType } from '../../../features/vehicles/infrastructure/enums/reading-type.enum';
import { VehicleReason } from '../../../features/vehicles/infrastructure/enums/vehicle-reasons.enum';
import { VehicleStatus } from '../../../features/vehicles/infrastructure/enums/vehicle-status.enum';

export const initialState: GetVehicleResponse = {
    mroType: MROType.ODOMETER_CAPTURE,
    id: 'testId',
    status: {
        name: VehicleStatus.ENROLLED,
        reason: VehicleReason.USER_REQUESTED,
        dateTime: '2020-01-01',
        errors: [],
    },
    make: 'test Make',
    model: 'test Model',
    year: 2020,
    selectedAddressId: 'test address',
    availableModels: [],
    vin: '123456789abcdefgh',
    selectedModel: {
        id: 3,
        make: 'Tesla',
        baseModel: 'Model 3',
        model: '',
        year: 2020,
        summary: 'Summary',
        description: 'description',
        displacement: {
            value: 3,
            unit: 'L',
        },
        drive: {
            code: 'ol',
            description: 'description drive',
        },
        cylinders: {
            value: 4,
            unit: 'L',
        },
        transmission: {
            value: 'auto',
        },
        engineDescription: {
            value: 'auto',
        },
        fuelType: {
            primary: 'gasoline',
            secondary: 'electric',
        },
    },
    addressData: {
        id: 'testId',
        alias: 'test alias',
        address: 'test address',
        zipCode: 'test zipCode',
        city: 'test city',
        county: 'test county',
        country: 'test country',
        state: {
            code: 'test code',
            name: 'test name',
        },
    },
    mroData: {
        id: 'testId',
        status: {
            name: MroStatus.ACTIVATED,
            reason: MroReason.PENDING_FIRST_CONNECTION,
            dateTime: '2020-01-01',
        },
        initialMilesReading: {
            reportingPeriodId: 'test reportingPeriodId',
            readingType: ReadingType.INITIAL_READING,
            miles: 1,
            readingDate: 'test readingDate',
            readingPeriodStartDate: 'test readingPeriodStartDate',
            readingPeriodEndDate: 'test readingPeriodEndDate',
            incrementMiles: 1,
        },
        lastMilesReading: {
            reportingPeriodId: 'test reportingPeriodId',
            readingType: ReadingType.DEACTIVATION_READING,
            miles: 1,
            readingDate: 'test readingDate',
            readingPeriodStartDate: 'test readingPeriodStartDate',
            readingPeriodEndDate: 'test readingPeriodEndDate',
            incrementMiles: 1,
        },
        finalMilesReading: {
            reportingPeriodId: 'test reportingPeriodId',
            readingType: ReadingType.COMPLIANCE_RECOVERY_READING,
            miles: 1,
            readingDate: 'test readingDate',
            readingPeriodStartDate: 'test readingPeriodStartDate',
            readingPeriodEndDate: 'test readingPeriodEndDate',
            incrementMiles: 1,
        },
        createdAt: 'test createdAt',
        updatedAt: 'test updatedAt',
    },
};

export const vehicleReducer = createReducer(
    initialState,
    on(loadVehicle, (state, action) => {
        return {
            ...state,
            ...action.vehicle,
        };
    })
);
